/**
 * Number of passengers a promotional code discount applies to.
 *
 * The per-code discount is granted **per passenger, babies excluded**: a lap
 * infant (< 2y) does not occupy a paid seat, so no discount is granted for it.
 * Every other category (adults, seniors, youngsters, children/`infants`) counts.
 *
 * Shared by the server (discount computation) and the web/back-office UIs
 * (per-passenger breakdown display) so the rule stays in one place.
 */
export function countBillablePassengers(passengersCount) {
    if (!passengersCount)
        return 0;
    return ((passengersCount.adults ?? 0) +
        (passengersCount.infants ?? 0) +
        (passengersCount.seniors ?? 0) +
        (passengersCount.youngsters ?? 0));
}
